import { Component, EventEmitter, forwardRef, Input, OnInit, Output, OnChanges } from '@angular/core';
import { FormBuilder, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ApiRoutes } from 'src/app/services/apiroutes';
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";


@Component({
  selector: 'logzy-money-field',
  templateUrl: './money-field.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MoneyFieldComponent),
    }
  ]
})
export class MoneyFieldComponent extends BaseControlValueAccessor implements OnInit {

  @Input()
  stepValue: number = 0.01;

  @Input()
  minValue: number = Number.MIN_VALUE;

  @Input()
  maxValue: number = Number.MAX_VALUE;

  @Input()
  customCurrencyFieldName = null;

  currencyUrl = `${ApiRoutes.CurrencyMaster}currency/?currency_code=::search::`;

  @Input()
  formFieldName = null;

  @Input()
  amount: number = 0.0;

  @Input()
  curdisabled: boolean = false;

  @Input()
  maxlength: number = 10; // Mandatory input

  @Input()
  minlength: number = 0;

  @Output()
  amountChange = new EventEmitter<number>();

  _currency = { currency_code: 'USD' };

  @Input()
  get currency() {
    return this._currency.currency_code;
  }
  set currency(val) {
    this._currency.currency_code = val;
  }
  @Output()
  currencyChange = new EventEmitter<string>();

  @Output()
  currencyCodeChange = new EventEmitter<string>();

  @Input()
  currencyCode: string;

  @Input() fromRO: boolean = false;

  ngOnInit(): void {
  }

  setAmount(amt) {
    this.amount = amt;
    this.validate(amt)
    this.amountChange.emit(amt);
    this._errors = [];
  }

  onFocusOut(event) {
    this.amount = this.roundoff_decimal(this.amount)
    this.amountChange.emit(this.amount);
  }

  // setCurrency(curr) {
  //   if (curr) {
  //     this.currencyCodeChange.emit(curr.currency_code);
  //   }
  // }

  getDisplay() {
    if (this.amount != null) {
      return `${this.amount} ${this.currencyCode}`
    } else {
      return '-'
    }
  }

  getUpdatedvalue(event) {
    this.currencyCode = event;
    this.currencyCodeChange.emit(this.currencyCode);
  }

  default(event) {
    if (event.keyCode == 101 || event.keyCode == 43 || event.keyCode == 45) {
      event.preventDefault();
    }
    // e=keyCode: 101
    //  +=keyCode43
    //   -=keyCode:45
  }

  override validate(val) {
    this.errors = [];

    // if (val < this.minValue && !(val == null || val == undefined)) {
    //   this.errors.push(`Minimum value permitted is ${this.minValue}`);
    // }

    // if (val > this.maxValue) {
    //   this.errors.push(`Maximum value permitted is ${this.maxValue}`);
    // }

    // if (this.amount) {
    //   const num = Number(val).toFixed(2);
    //   if (num) {
    //     this.errors.push(`Enter valid currency.`);
    //   }
    // }
  }
}
